import { AddressModels } from './address.models';
import { CommonModels } from './common.models';
import { DocumentModels } from './document.models';

export namespace SubscriptionModels {
  export class SubscriptionForm {
    civility?: CommonModels.CivilityEnum;
    firstName?: string;
    lastName?: string;
    phone?: string;
    mobile?: string;
    email?: string;
    nomCabinet?: string;
    address?: AddressModels.Address;
    numSiret?: string;
    isHeadOfAgency?: boolean;
    turnover?: number;
    employeeCount?: number;
    outletCount?: number;
  }

  export interface ProgressList {
    emails: Progress;
    documents: Progress;
    messages: Progress;
    welcomeCalls: Progress;
    relaunchCalls: Progress;
  }

  export interface Progress {
    total: number;
    current: number;
  }

  export interface SubscriptionDocumentInformation
    extends DocumentModels.Document {
    data: DocumentModels.DocumentInformation;
    customRejects: CustomReject[];
    rejects: PredefinedReject[];
  }

  export interface PredefinedReject extends CustomReject {
    id: number;
  }

  export interface CustomReject {
    message: string;
    active: boolean;
  }

  export interface PostSubscriptionDocumentInformationsRequest {
    data: DocumentModels.DocumentInformation;
    state: DocumentModels.DocumentStateEnum;
    rejects: PredefinedReject[];
    customRejects: string[];
  }
}
